import { CURRENT_EDIT_MEMBER } from './types.js';
const currentEditMember = (
  { name, email, subscriptions, id, companyName, role, responseGenerated, assignedLeads },
  state
) => {
  const newCurrentUserDetails = {
    ...state,
    name,
    email,
    subscriptions,
    id,
    companyName,
    role,
    responseGenerated,
    assignedLeads,
  };
  return {
    ...newCurrentUserDetails,
  };
};

export default (state, action) => {
  switch (action.type) {
    case CURRENT_EDIT_MEMBER:
      return currentEditMember(action.payload, state);
    default:
      return state;
  }
};
